import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SeleccionInformesScreen from './screen';
import { ServerErrorMessage } from '../../../../../../shared/utils/error';
import { useNotifications} from '../../../../../../shared/hooks/Notifications';
import { InformesDetalleAdapter } from '../../../../../../infraestructure/persistence/rest/InformesDetalleAdapter';
import { PeriodosAdapter } from '../../../../../../infraestructure/persistence/rest/PeriodosAdapter';

import { downloadFile } from '../../../../../../shared/utils/download';

export const SeleccionInformesContainer = () => {

	const api = new InformesDetalleAdapter();
	const apiPeriodos = new PeriodosAdapter();
	const {resultError, exceptionError, launchNotification} = useNotifications();
	
	let [ data, setData ] = useState<any>([]);
	let [isLoading, setIsLoading] = useState<boolean>(false);
	let [año, setAño] = useState<any>(undefined);
	let [periodo, setPeriodo] = useState<any>(undefined);
	let [reunion, setReunion] = useState<any>(undefined);

	let result: any;

	useEffect(()=>{
		getTiposContenido();
	  },[])
	
	const getTiposContenido = async () => {
		try {
			setIsLoading(true);
			result = await apiPeriodos.getTiposContenidoPeriodoAbierto();
			if(result.data && result.data!=="")
			{
				var data = ([ ...result.data ] || []);
				if(data.length > 0){						
					setAño(([ ...result.data ] || [])[0].año);
					setPeriodo(([ ...result.data ] || [])[0].periodo);
					setReunion(([ ...result.data ] || [])[0].reunion);
				}else{
					setAño(undefined);
					setPeriodo(undefined)
					setReunion(undefined);
				}
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
		setIsLoading(false);
	};

	const DescargarInforme = async (data: any) => {
		setIsLoading(true);
		try {
			launchNotification({type:"warning",title:"Datos Excel",message:"Ten en cuenta que los datos puede que no sean los definitivos, consulta con Control Gestión para estar seguro."}, false);
			result = await api.DescargarInforme(data);
			if(result.data && result.data!=="")
			{
				downloadFile(result.data, data.IdTipoInforme + '_' + data.IdTipo + '_' + data.año + '_' + data.periodo + '.xlsx');
			}else{resultError();}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
		setIsLoading(false);
  	};

	return (
		<>
			<SeleccionInformesScreen data={data} año={año} periodo={periodo} reunion={reunion} onExport={DescargarInforme} isLoading={isLoading} />
		</>
	);
};

export default SeleccionInformesContainer;